import { forwardRef, type Ref, type SVGProps } from "react";
const IconBusOutlineSVG = (
  { children, ...rest }: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    viewBox="0 0 32 32"
    ref={ref}
    {...rest}
  >
    {children}
    <rect width={2} height={4} x={1} y={12} fill="currentColor" rx={1} />
    <rect width={2} height={4} x={29} y={12} fill="currentColor" rx={1} />
    <path
      fill="currentColor"
      d="M22 19a1 1 0 1 0 0 2 1 1 0 1 0 0-2m-12 0a1 1 0 1 0 0 2 1 1 0 1 0 0-2"
    />
    <path
      fill="currentColor"
      d="M24.08 2H7.92A3.93 3.93 0 0 0 4 5.92v18.23A1.85 1.85 0 0 0 5.85 26H7v2a2 2 0 0 0 2 2h2a2 2 0 0 0 2-2v-2h6v2a2 2 0 0 0 2 2h2a2 2 0 0 0 2-2v-2h1.15A1.85 1.85 0 0 0 28 24.15V5.92A3.93 3.93 0 0 0 24.08 2M11 28H9v-2h2Zm12 0h-2v-2h2Zm3-4H6v-8h20Zm0-10H6V8h20Zm0-8H6v-.08A1.92 1.92 0 0 1 7.92 4h16.16A1.92 1.92 0 0 1 26 5.92Z"
    />
  </svg>
);
const ForwardRef = forwardRef(IconBusOutlineSVG);
ForwardRef.displayName = "IconBusOutline";
export { ForwardRef as IconBusOutline };
